<form #contactForm="ngForm"  (ngSubmit)="saveConsignorContacts()" class="consignor-contacts-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{consignorName}} - Contacts
    </h4>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button"
              class="btn btn-secondary me-2"
              (click)="closePopup()">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit"
              class="btn btn-primary"
              [disabled]="isLoader || (contactForm?.invalid)">
        <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader"></i>-->
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 sticky">
        <div class="row" style="height:50px">
          <div class="col-auto">
            <h2>NOTIFICATION CONTACT(S)</h2>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="data-grid">
          <table mat-table [dataSource]="dataSource" class="table">
            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110" style="width:15%">FIRST NAME</th>
              <td mat-cell *matCellDef="let element; let i = index" style="padding-right:10px">
                <input type="text"
                       class="form-control"
                       [ngClass]="{'form-required-border': firstName.invalid && (firstName.touched)}"
                       [(ngModel)]="element.firstName"
                       name="firstName_{{i}}"
                       #firstName="ngModel"
                       required>
                <span class="text-danger" *ngIf="firstName.invalid && (firstName.touched)">Firstname required</span>
              </td>
            </ng-container>

            <!-- Last Name Column -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110" style="width:15%">LAST NAME</th>
              <td mat-cell *matCellDef="let element; let i = index" style="padding-right:10px">
                <input type="text"
                       class="form-control"
                       [ngClass]="{'form-required-border': lastName.invalid && (lastName.touched)}"
                       [(ngModel)]="element.lastName"
                       name="lastName_{{i}}"
                       #lastName="ngModel"
                       required>
                <span class="text-danger" *ngIf="lastName.invalid && (lastName.touched)">Lastname required</span>
              </td>
            </ng-container>

            <!-- Email Address Column -->
            <ng-container matColumnDef="emailAddress">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110" style="width:20%">EMAIL ADDRESS</th>
              <td mat-cell *matCellDef="let element; let i = index" style="padding-right:10px">
                <input type="email"
                       class="form-control"
                       [ngClass]="{'form-required-border': emailAddress.invalid && (emailAddress.touched)}"
                       [(ngModel)]="element.emailAddress"
                       name="emailAddress_{{i}}"
                       #emailAddress="ngModel"
                       [required]="element.isReceiveRepoEmail"
                       email>

                <span  class="text-danger" *ngIf="emailAddress.invalid && (emailAddress.touched || element.isReceiveRepoEmail)">Invalid email</span>
              </td>
            </ng-container>

            <!-- Mobile Number Column -->
            <ng-container matColumnDef="phoneNumber">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110" style="width:20%">MOBILE NUMBER</th>
              <td mat-cell *matCellDef="let element; let i = index" style="padding-right:10px" class="phone-cell">
                <div class="d-flex">
                  <ngx-intl-tel-input [cssClass]="'phone-input-wrapper form-control'"
                                      [preferredCountries]="preferredCountries"
                                      [enableAutoCountrySelect]="true"
                                      [enablePlaceholder]="true"
                                      [searchCountryFlag]="true"
                                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                                      [selectFirstCountry]="false"
                                      [separateDialCode]="true"
                                      [selectedCountryISO]="element.selectedCountryISO"
                                      [phoneValidation]="true"
                                      [numberFormat]="PhoneNumberFormat.National"
                                      [(ngModel)]="element.internationalNumber"
                                      name="phoneNumber_{{i}}"
                                      id="phone_{{i}}"
                                      #phoneInput
                                      [required]="element.isReceiveRepoSMS"
                                      #phone="ngModel">

                  </ngx-intl-tel-input>

                </div>
                <span class="error-msg-phone text-danger">Invalid phone</span>

              </td>
            </ng-container>

            <!-- Receive Repo Email Column -->
            <ng-container matColumnDef="receiveRepoEmail">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110 text-center" style="width:10%">RECEIVE REPO EMAIL</th>
              <!-- Replace checkbox inputs with this version -->
              <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                <mat-checkbox [(ngModel)]="element.isReceiveRepoEmail" name="isReceiveRepoEmail_{{i}}"></mat-checkbox>
              </td>
            </ng-container>

            <!-- Receive Repo SMS Column -->
            <ng-container matColumnDef="receiveRepoSms">
              <th mat-header-cell *matHeaderCellDef class="w-15-rem th-top-110 text-center" style="width:10%">RECEIVE REPO SMS</th>
              <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                <mat-checkbox [(ngModel)]="element.isReceiveRepoSMS" name="isReceiveRepoSMS_{{i}}"></mat-checkbox>
              </td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="th-top-110" style="width:1%">ACTION</th>
              <td mat-cell *matCellDef="let element; let i = index" style="padding-right:10px">
                <a class="btn btn-outline-primary btn-sm"
                   (click)="removeContact(i)"
                   title="Remove Contact">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let saleIndex = index"
                class="border-start-0 border-end-0 pointer pt-2 tr-fs-13px"></tr>
          </table>

          <div class="actions">
            <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isLoader" (click)="addNewContact()">
              <i class="fa fa-plus"></i> Add Contact
            </button>
          </div>

          <div class="row g-2" style="padding-top:50px">
            <div class="col-2" style="text-align:right">
              <label class="mt-1 mr-1">Analytics Url</label>
            </div>
            <div class="col-5">
              <input type="text"
                     class="form-control"
                     [(ngModel)]="link"
                     #linkInput
                     name="analyticsUrl"
                     #analyticsUrl="ngModel"
                     readonly>
              
            </div>
            <div class="col-4">
              <button type="button" mat-icon-button class="btn btn-outline-primary btn-sm" (click)="copyLink()">
                Copy
              </button>
            </div>
          </div>
        </div>
        
        <!--<div class="row" *ngIf="isLoader">
          <div class="col-md-12 text-center">
            Loading <i class="fa fa-spinner fa-spin"></i>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</form>
